






















import { mapState, mapActions } from 'vuex'
import { isControlledBackendError, applyCustomErrorConfig } from '@/custom-errors'
import { validate } from '@/services/password'
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import PublicPageContent from '@/components/PublicPageContent.vue'
import PasswordSetupLinkExpired from './PasswordSetupLinkExpired.vue'
import PasswordSetupForm from './PasswordSetupForm.vue'
import WithThemeTitle from '../../../components/WithThemeTitle.vue'

export default {
  components: {
    WithThemeTitle,
    LoadingSpinner,
    PublicPageContent,
    PasswordSetupLinkExpired,
    PasswordSetupForm
  },
  props: {
    personId: { type: String, required: true },
    uid: { type: String, required: true },
    token: { type: String, required: true }
  },
  data() {
    return { isLoading: true }
  },
  computed: {
    ...mapState(['authentication'])
  },
  async created() {
    try {
      await this.checkResetLinkExpiration({
        personId: this.personId,
        token: this.token
      })
    } catch (err) {
      this.showErrorMessage(err)
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    ...mapActions([
      'checkResetLinkExpiration',
      'sendPasswordResetEmail',
      'sendNewPassword'
    ]),
    validatePassword(password) {
      return validate(this.personId, password)
    },
    async submitNewPassword(passwordFormInfo) {
      try {
        await this.sendNewPassword({
          personId: this.personId,
          uid: this.uid,
          token: this.token,
          ...passwordFormInfo
        })
        await this.$router.push('/auth/registration/confirmation')
      } catch (err) {
        this.showErrorMessage(err)
      }
    },
    async sendNewLink() {
      try {
        await this.sendPasswordResetEmail(this.personId)
        await this.$router.push('/auth/email-sent')
      } catch (err) {
        this.showErrorMessage(err)
      }
    },
    showErrorMessage(err) {
      // in case of wrong token (401) or wrong person ID (404) just show generic error message
      this.alertModal.showErrorMessage(
        this.$t('serverError.title'),
        isControlledBackendError(err)
          ? err.message
          : this.$t('serverError.PasswordError'),
        applyCustomErrorConfig
      )
    }
  }
}
